import { render } from "./PotentialDetailsV2.vue?vue&type=template&id=b3f40b2a&scoped=true&lang=pug"
import script from "./PotentialDetailsV2.vue?vue&type=script&setup=true&lang=js"
export * from "./PotentialDetailsV2.vue?vue&type=script&setup=true&lang=js"

import "./PotentialDetailsV2.vue?vue&type=style&index=0&id=b3f40b2a&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3f40b2a"]])

export default __exports__